import Vue from 'vue';
import { fromEvent } from 'rxjs';
import { tap, first } from 'rxjs/operators';
import Spinner from '../components/Spinner.vue';

const SpinnerClass = Vue.extend(Spinner);

export default {
  bind(el, binding, vnode) {
    const options = {
      propsData: {
        variant: el.getAttribute('loader-variant'),
        small: el.hasAttribute('loader-small'),
      },
    };
    // create spinner component
    el.loader = new SpinnerClass(options);
    el.loader.$mount();

    // origin text
    el.text = el.innerHTML;

    // click observable
    const click$ = fromEvent(el, 'click');
    el.click$ = click$.subscribe(() => {
      el.innerHTML = '';
      el.appendChild(el.loader.$el);
      el.disabled = true;

      const observable$ = binding.value.call(binding.value, vnode.data.attrs.params);
      observable$.pipe(
        first(),
        tap(() => {
          el.removeChild(el.loader.$el);
          el.disabled = false;
          el.innerHTML = el.text;
        }),
      ).subscribe();
    });
  },
  inserted(el) {
    // set min size
    el.style.minWidth = `${el.offsetWidth}px`;
    el.style.minHeight = `${el.offsetHeight}px`;
  },
  unbind(el) {
    el.loader.$destroy();
    el.click$.unsubscribe();
  },
};
